import * as React from 'react';

const ScanChunkySvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            d="M13 11V7h-2v4H7v2h4v4h2v-4h4v-2h-4zm9-1.965V2h-6.985v2.022h5.033v5.013H22zM14.975 22.01v-1.952h5.013v-5.033h2.022v6.985h-7.035zM9.023 2v1.952h-5v5.063H2V2h7.023zm-7.02 12.996h1.953v5h5.063v2.023H2.004v-7.023z"
            fillRule="evenodd"
        />
    </svg>
);

ScanChunkySvg.displayName = 'ScanChunkySvg';
export default ScanChunkySvg;
